import {
  PolarisChatAggregate,
  PolarisChatOverview,
  PolarisDataDomain,
  PolarisOrigin,
  PolarisTurn,
  PolarisWidgetContext
} from './polaris-domain.models';
import {PolarisAccountKey, PolarisBrandKey, PolarisChatId, PolarisCompetitorKey, PolarisMessageId} from './polaris-api.models';

export interface PolarisPaginationState {
  limit: number;
  offset: number;
  total: number;
}

export interface PolarisLoadingState {
  overview: boolean;
  activeChat: boolean;
  sendMessage: boolean;
  migration: boolean;
}

export interface PolarisErrorState {
  overview: string | null;
  activeChat: string | null;
  sendMessage: string | null;
  migration: string | null;
}

export interface PolarisMigrationState {
  isRunning: boolean;
  isCompleted: boolean;
  lastRunAt: number | null;
  attempts: number;
  lastError: string | null;
}

export interface PolarisRepositoryState {
  accountKey: PolarisAccountKey | null;
  chatsById: Record<PolarisChatId, PolarisChatAggregate>;
  hydratedChatIds: Record<PolarisChatId, boolean>;
  chatOrder: PolarisChatId[];
  activeChatId: PolarisChatId | null;
  recentChatId: PolarisChatId | null;
  recentChatIdTimeout: NodeJS.Timeout | null;
  pagination: PolarisPaginationState;
  loading: PolarisLoadingState;
  errors: PolarisErrorState;
  migration: PolarisMigrationState;
}

export interface PolarisOptimisticSendInput {
  chatId: PolarisChatId;
  userPrompt: string;
  requestId: string;
  interactionId: string;
  timestamp: number;
  origin?: PolarisOrigin;
  dataDomain?: PolarisDataDomain;
  widgetName?: string;
  widgetContext?: PolarisWidgetContext;
  myBrand?: PolarisBrandKey;
  myCompetitors?: PolarisCompetitorKey[];
}

export interface PolarisSendReconcileInput {
  chat: PolarisChatOverview;
  turn: PolarisTurn;
}

export interface PolarisTransientIndex {
  requestToPendingMessageId: Record<string, PolarisMessageId>;
  interactionToRequestId: Record<string, string>;
}

export enum ChatViewType {
  OWNED = 'owned',
  SHARED = 'shared',
  COPIED = 'copied'
}

export interface ChatViewConfig {
  [ChatViewType.OWNED]: {mode: ChatViewType.OWNED};
  [ChatViewType.SHARED]: {mode: ChatViewType.SHARED; sharedChatId: PolarisChatId; copyInFlight: boolean};
  [ChatViewType.COPIED]: {mode: ChatViewType.COPIED; forkedFromChatId: PolarisChatId};
}

export type ChatViewState = ChatViewConfig[ChatViewType];
